import React from 'react';
import PropTypes from 'prop-types';

import FileSystem from 'components/file_system';
import Dropdown from 'components/dropdowns/dropdown';
import { faTrash, faFileExport, faImage } from '@fortawesome/pro-solid-svg-icons';

export class DocumentList extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    currentFolder: PropTypes.shape({
      breadcrumbs: PropTypes.array,
      children: PropTypes.array,
      root: PropTypes.bool
    }),
    dragSourceIndex: PropTypes.number,
    dropTargetIndex: PropTypes.number,
    highlightedDocumentId: PropTypes.number,
    onAddToListingMedia: PropTypes.func,
    onBeginDrag: PropTypes.func.isRequired,
    onDeleteDocument: PropTypes.func.isRequired,
    onDeleteFolder: PropTypes.func.isRequired,
    onEndDrag: PropTypes.func.isRequired,
    onFilePreview: PropTypes.func.isRequired,
    onFolderSelect: PropTypes.func.isRequired,
    onMoveToParent: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired,
    onToggleMarketing: PropTypes.func,
    onUpdateDocument: PropTypes.func.isRequired,
    onUpdateFolder: PropTypes.func.isRequired
  }

  state = {
    currentFolder: this.props.currentFolder,
    selectedFiles: [],
    sort: {
      key: null,
      reverse: false
    }
  }

  handleNavigation = (folder) => {
    this.props.onFolderSelect(folder.id);
  }

  static getDerivedStateFromProps({ currentFolder }) {
    return { currentFolder };
  }

  allSelected = () => this.state.currentFolder.children.every(child => child.selected)

  selectAllFiles = () => {
    const allSelected = this.allSelected();
    this.setState((state) => {
      const { currentFolder } = state;
      currentFolder.children = currentFolder.children.map((child) => {
        return { ...child, selected: !allSelected };
      });

      return { currentFolder };
    });
  }

  isHighlighted = (docId) => {
    return docId === this.props.highlightedDocumentId;
  }

  handleHeaderClick = (key) => {
    if (!key) return;
    this.setState((state) => {
      const { sort } = { ...state };
      if (sort.key == key) {
        sort.reverse = !sort.reverse;
      } else {
        sort.reverse = false;
        sort.key = key;
      }
      return { sort };
    });
  }

  handleFileSelect = (file) => {
    this.setState((state) => {
      const { currentFolder } = state;

      file = currentFolder.children.find(child => child == file);
      file.selected = !file.selected;

      return { currentFolder };
    });
  }

  sortedChildren() {
    const { children } = this.state.currentFolder;
    const { sort } = this.state;
    if (!sort.key) return children;

    const sorted = children.sort((a, b) => {
      return (a[sort.key] || '').localeCompare(b[sort.key] || '', 'en', { sensitivity: 'base' });
    });
    return sort.reverse ? sorted.reverse() : sorted;
  }

  breadcrumbs = () => {
    const { currentFolder } = this.props;
    return [...currentFolder.breadcrumbs, currentFolder];
  }

  handleFileRename = (file, name) => {
    const method = file.folder ? this.props.onUpdateFolder : this.props.onUpdateDocument;
    method(file.id, { name });
  }

  toggleMarketing = (doc) => {
    const { contextId, id, marketing, folder } = doc;

    this.props.onToggleMarketing(!marketing, id, (contextId || id), folder);
  }

  actionsFor = (doc) => {
    const { onAddToListingMedia, onDeleteFolder, onDeleteDocument, onMoveToParent } = this.props;
    const moveToFolder = doc.marketing ? 'Attachments' : 'Documents';
    const actions = [
      {
        label: 'Delete',
        key: 'delete',
        icon: faTrash,
        callback: () => doc.folder ? onDeleteFolder(doc.id) : onDeleteDocument(doc.id)
      },
      {
        label: `Move to ${moveToFolder}`,
        key: 'toggleMarketing',
        icon: faFileExport,
        callback: () => this.toggleMarketing(doc)
      },
    ];

    if (this.props.onAddToListingMedia && !doc.folder) {
      actions.push({
        label: 'Add to Listing Media',
        key: 'addToListingMedia',
        icon: faImage,
        callback: () => onAddToListingMedia(doc.id)
      });
    }

    if (!this.state.currentFolder.root) {
      actions.push({
        label: 'Move to Parent Folder',
        key: 'moveUp',
        icon: faFileExport,
        callback: () => onMoveToParent(doc)
      });
    }

    return actions;
  }

  render() {
    const { dragSourceIndex, dropTargetIndex } = this.props;
    const dndProps = { dragSourceIndex, dropTargetIndex };

    return (
      <React.Fragment>
        <div className="row-eq-height">
          <div className="grow">
            <FileSystem.Breadcrumbs folders={this.breadcrumbs()} onNavigation={this.handleNavigation}/>
          </div>
          <div>
            {this.props.children}
          </div>
        </div>
        <FileSystem.Table
          allSelected={this.allSelected()}
          excludedColumns={['select', 'createdBy', 'lastAccessed']}
          sort={this.state.sort}
          onHeaderClick={this.handleHeaderClick}
          onSelectAll={this.selectAllFiles}
          {...dndProps}
        >
          {this.renderRows()}
        </FileSystem.Table>
      </React.Fragment>
    );
  }

  renderRows() {
    const { onBeginDrag, onEndDrag, onReorder } = this.props;
    const dndProps = { onBeginDrag, onEndDrag, onReorder };
    return this.sortedChildren().map((doc, idx) => {
      return (
        <FileSystem.Row
          actions={this.actionsFor(doc)}
          dropdownComponent={Dropdown}
          excludedColumns={['select', 'owner', 'lastAccessed']}
          file={doc}
          highlighted={this.isHighlighted(doc.id)}
          index={idx}
          key={doc.id}
          onNavigation={this.handleNavigation}
          onPreview={this.props.onFilePreview}
          onRename={this.handleFileRename}
          onSelect={this.handleFileSelect}
          {...dndProps}
        />
      );
    });
  }
}

export default DocumentList;
